import img1 from "../Assets/gallery/img1.jpeg";
import img2 from "../Assets/gallery/img2.jpeg";
// import img3 from "../Assets/gallery/img3.jpeg"
import img4 from "../Assets/gallery/img4.jpeg";
import img5 from "../Assets/gallery/img5.jpeg";
import img6 from "../Assets/gallery/img6.jpeg";
import img7 from "../Assets/gallery/img7.jpeg";
import img8 from "../Assets/gallery/img8.jpeg";

export const MediaData = [img1, img2, img4, img5, img6, img7, img8];
